import { render } from "./StationPassportTable.vue?vue&type=template&id=8c70992a&scoped=true"
import script from "./StationPassportTable.vue?vue&type=script&lang=js"
export * from "./StationPassportTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=8c70992a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c70992a"]])

export default __exports__